import Vue from "vue";
import Vuex from "vuex";
import VuexPersistedState from "vuex-persistedstate";
import LogRocket from "logrocket";
import createPlugin from "logrocket-vuex";

const logrocketPlugin = createPlugin(LogRocket);

import modules from "./modules";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== "production",
  plugins: [
    VuexPersistedState({
      storage: window.sessionStorage
    }),
    logrocketPlugin
  ]
});

// Session storage can restore a previous rolesResolved flag before this
// visit's GetImpersonate call. Bulk-upload access waits for that call.
store.commit("auth/CLEAR_ROLES_RESOLUTION");

export default store;
